/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Laptop = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M19.25 3C20.7688 3 22 4.23122 22 5.75V14.5H20.5V5.75C20.5 5.05964 19.9404 4.5 19.25 4.5H4.75C4.05964 4.5 3.5 5.05964 3.5 5.75V14.5H2V5.75C2 4.23122 3.23122 3 4.75 3H19.25ZM13 6V7.5H11V6H13ZM23 16V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V16H23ZM21.5 17.5H2.5V19C2.5 19.2455 2.67688 19.4496 2.91012 19.4919L3 19.5H21C21.2761 19.5 21.5 19.2761 21.5 19V17.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
